import styled from "styled-components";

export const MainContainerParentStyle = styled.div`
 background-color: ${({ theme }) => theme.mainBackground};
 margin: auto;
`;
